import React from 'react';
import { AdminTabBar } from './components/admin/AdminTabBar';
interface WizardLayoutProps {
  children: React.ReactNode;
}

/**
 * Full-width layout for wizard flows.
 *
 * Unlike AdminLayout, this layout:
 * - Hides the sidebar completely for full-width content
 * - Renders inside the shell frame, which owns the nav rail
 * - Provides padding appropriate for wizard UIs
 */
export default function WizardLayout({ children }: WizardLayoutProps) {
  return (
    <div className="h-full bg-slate-50 overflow-hidden">
      <div className="flex h-full overflow-hidden">
        <div className="flex-1 flex flex-col min-w-0">
          <AdminTabBar />
          <main className="flex-1 min-h-0 overflow-hidden">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}
